import { GetToursErrorTypes } from 'sletat-api-services/lib/module/getTours/getToursAsyncService';


export enum SearchStatus {
    Initial = 'initial',
    InProcess = 'in_progress',
    Success = 'success',
    Failed = 'failed'
}

export interface SearchError {
    type: GetToursErrorTypes;
    message: string;
}
